const passwordStrength = {
  passwordStrength: {
    minimumCharacters: "Your password should have at least 8 characters.",
    caps: "You must use a combination of upper and lower case.",
    specialCharacters: "You must include numbers and special characters.",
  },
};

export default passwordStrength;
